// reducers/userReducer.js
const initialState = {
    profilePhotoURL: null,
    isLoading: false,
    error: null,
  };
  
  const userReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'FETCH_PROFILE_PHOTO_REQUEST':
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case 'FETCH_PROFILE_PHOTO_SUCCESS':
        return {
          ...state,
          profilePhotoURL: action.payload,
          isLoading: false,
        };
      case 'FETCH_PROFILE_PHOTO_FAILURE':
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default userReducer;
  